module.exports = __webpack_public_path__ + "static/media/logo-uach-renovacion.4bcd2228.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-uach-renovacion.png
// module id = 782
// module chunks = 0